import { useMemo, useState } from 'react';
import { PostCard } from '@/components/feed/PostCard';
import { PhotoLightbox } from '@/components/feed/PhotoLightbox';
import { useFeed } from '@/hooks/useFeed';


export const HomePage = () => {
  const { data, isLoading } = useFeed();
  const [selectedPostId, setSelectedPostId] = useState<string | null>(null);

  const selectedPost = useMemo(
    () => data?.items.find((p) => p.id === selectedPostId) ?? null,
    [data, selectedPostId],
  );

  return (
    <>
      <section className="space-y-6">
        <div className="space-y-3">
          <p className="text-sm uppercase tracking-[0.25em] text-white/45">Hello Welcome to my Gallery</p>
          <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl">
            A curated collection of photos from Renggani Reswari.
          </h1>
          <p className="max-w-2xl text-sm text-white/65 sm:text-base">
             Browse photos shared by Renggani Reswari, react to your favorites, and enjoy every moment in one beautiful gallery💚.
          </p>
        </div>

        <div className="grid card-grid gap-5">
          {isLoading &&
            Array.from({ length: 6 }).map((_, index) => (
              <div key={index} className="glass animate-pulse rounded-[28px] p-4">
                <div className="aspect-[4/5] rounded-3xl bg-white/5" />
                <div className="mt-4 h-4 w-3/4 rounded bg-white/5" />
                <div className="mt-3 h-4 w-1/2 rounded bg-white/5" />
              </div>
            ))}

          {data?.items.map((post) => (
            <PostCard key={post.id} post={post} onOpen={(post) => setSelectedPostId(post.id)} />
          ))}
        </div>
      </section>

      <PhotoLightbox
        post={selectedPost}
        open={Boolean(selectedPostId)}
        onOpenChange={(open) => {
          if (!open) setSelectedPostId(null);
        }}
      />
    </>
  );
};